import httpClient from "@/API/HttpClient";

// Login
const login = (params) =>
  httpClient.post(`connect/token`, params, {
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
    },
  });

// Menu
const getReport = (kind, colkey, min, max) =>
  httpClient.get(
    `api/Report?kind=${kind}&colkey=${colkey || ""}&min=${min || ""}&max=${
      max || ""
    }`
  );

//Report
const chartReport = (
  colkeyvalue,
  colkeyvalue1,
  colkeyvalue2,
  year,
  month,
  day
) =>
  httpClient.get(
    `api/TolidReport?colkeyvalue=${colkeyvalue || ""}&colkeyvalue1=${
      colkeyvalue1 || ""
    }&colkeyvalue2=${colkeyvalue2 || ""}&year=${year || ""}&month=${
      month || ""
    }&day=${day || ""}`
  );

const saleProductReport = (timetype, numbertype, year, month, day) =>
  httpClient.get(
    `api/Horeka_SaleBykalaGroup?timetype=${timetype || ""}&numbertype=${
      numbertype || ""
    }&year=${year || ""}&month=${month || ""}&day=${day || ""}`
  );

const saleCountReport = (timetype, numbertype, year, month, day) =>
  httpClient.get(
    `api/Horeka_SaleCount?timetype=${timetype || ""}&numbertype=${
      numbertype || ""
    }&year=${year || ""}&month=${month || ""}&day=${day || ""}`
  );

const horekaSaleReport = (timetype, numbertype, year, month, day) =>
  httpClient.get(
    `api/Horeka_Sale?timetype=${timetype || ""}&numbertype=${
      numbertype || ""
    }&year=${year || ""}&month=${month || ""}&day=${day || ""}`
  );

export {
  login,
  getReport,
  chartReport,
  saleProductReport,
  saleCountReport,
  horekaSaleReport,
};
